import classes from './index.module.scss'

interface Props {
  leftColumn: JSX.Element
  rightColumn: JSX.Element
}

export const TwoColumn = ({ leftColumn, rightColumn }: Props) => (
  <div className={classes.root}>
    <div className={classes.left}>{leftColumn}</div>
    <div className={classes.right}>{rightColumn}</div>
  </div>
)
